import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "../service/tekkr-service";
import { useProject } from "../project";

export function useAddProjectCollaboratorMutation() {
    const { project } = useProject();
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async (userIds: string[]) => {
            const res = await apiClient.addProjectCollaborator({
                params: { projectId: project.id },
                body: { userIds },
            });
            if (res.status !== 200) {
                throw new Error("Failed to add collaborator");
            }
            return res.body;
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["project", project.id] });
        },
    });
}
